import React, { useState } from 'react'
import './AttachList.css'
import { AttachmentsProvider } from '../../context/AttachmentContext'
import { AttachmentModal } from './AttachModal'

interface AttachListProps {
  manuals?: string[]
  assets?: string[]
  harness?: string[]
}

const AttachListSection: React.FC<{ title: string, items?: string[] }> = ({ title, items }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedNumber, setSelectedNumber] = useState('')

  const handleItemClick = (item: string): void => {
    setSelectedNumber(item)
    setIsModalOpen(true)
  }

  return (
    <div className='attach-list__section'>
      <h3 className='attach-list__title'>{title}</h3>
      <ul className='attach-list__items'>
        {items?.map((item, index) => (
          <li key={index}>
            <button
              className='attach-list__item-button'
              onClick={() => handleItemClick(item)}
            >
              {item}
            </button>
          </li>
        ))}
      </ul>
      {/*       <button className='attach-list__view-all'>
        <strong>Add {title}</strong>
      </button> */}
      <AttachmentModal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        attachmentNumber={selectedNumber}
      />
    </div>
  )
}

const AttachList: React.FC<AttachListProps> = ({ manuals, assets, harness }) => {
  return (
    <div className='attach-list'>
      <AttachmentsProvider>
        <AttachListSection title='Manuals' items={manuals} />
        <AttachListSection title='Assets' items={assets} />
        <AttachListSection title='Harness' items={harness} />
      </AttachmentsProvider>
    </div>
  )
}

export default AttachList
